"use client";

import { Box } from "@mui/material";
import {
  TOP_NAV_WIDTH_MOBILE_MAX,
  TOP_NAV_HEIGHT_DESKTOP_NUMBER,
  TOP_NAV_HEIGHT_MOBILE_NUMBER,
} from "./GlobalNav";
import useHasSubNav from "./useHasSubNav";

export const SEARCH_FILTER_BAR_HEIGHT = 76;

export default function PageBody({ children }: { children: React.ReactNode }) {
  const { hasSubNav: isSearch } = useHasSubNav();
  return (
    <Box
      sx={(theme) => ({
        flexGrow: 1,
        paddingTop: TOP_NAV_HEIGHT_DESKTOP_NUMBER + 'px',
        [theme.breakpoints.down(TOP_NAV_WIDTH_MOBILE_MAX)]: {
          paddingTop: (TOP_NAV_HEIGHT_MOBILE_NUMBER + (isSearch ? SEARCH_FILTER_BAR_HEIGHT : 0)) + 'px',
        },
      })}
    >
      {children}
    </Box>
  );
}
